import {
  FindSkillAreasParamsType,
  SkillArea,
  SkillAreaType,
} from "@/types/CourseSkill";
import { getConfig } from "@/utils/config";
import { HttpResponse } from "@/utils/http-client";
import useSWR from "swr";

export function useGetCourseSkills({ level }: FindSkillAreasParamsType) {
  return useSWR<SkillAreaType[], HttpResponse<any, any>>(
    "getCourseSkills" + level,
    async () => {
      const params = { level };
      for (const key of Object.keys(params)) {
        if (!params[key as keyof typeof params]) {
          delete params[key as keyof typeof params];
        }
      }
      const courses = new SkillArea(getConfig());
      return (await courses.findSkillAreas(params)).data;
    },
    {
      revalidateOnFocus: false,
    }
  );
}
